export default __webpack_public_path__ + "static/media/Blades Whetted by Teardrops.1068c916.png";